import { takeEvery, all, put, call } from 'redux-saga/effects'
import { RequestStatus } from 'features/common'
import { setBlogPosts, setBlogPostsStatus, setBlogPostsError, fetchBlogPostsRequest } from './homeSlice'
import { createApiError } from 'features/common/api/apiError'

import { getBlogPosts } from '../api/home'

function* fetchBlogPosts() {
  try {
    yield put(setBlogPostsStatus(RequestStatus.Pending))
    const blogPosts = yield call(getBlogPosts)
    yield put(setBlogPosts(blogPosts))
    yield put(setBlogPostsStatus(RequestStatus.Fulfilled))
  } catch (e) {
    yield put(setBlogPostsStatus(RequestStatus.Rejected))
    yield put(setBlogPostsError(createApiError(e)))
  }
}

function* watchFetchHome() {
  yield takeEvery(fetchBlogPostsRequest.type, fetchBlogPosts)
}

export default function* homeSagas() {
  try {
    yield all([watchFetchHome()])
  } catch (e) {
    console.error(e)
  }
}
